import React from "react"
import { fieldToTextField } from "./TextField"
import { Wysiwyg as JBWysiwyg } from "shared/ui/berry-jass/Wysiwyg"

export const Wysiwyg = (props) => {
  const onChange = (value) => {
    props.form.setFieldValue(props.field.name, value)
    props.form.setFieldTouched(props.field.name, true, false)
    if (props.onChange) {
      props.onChange(value)
    }
  }

  return <JBWysiwyg {...fieldToTextField(props)} onChange={onChange} />
}
